import { Component, OnInit, Input } from '@angular/core';
import { TupAuthService, AuthEvent } from '@telmar-global/tup-auth';
import { OpenApiDataService } from 'src/app/services';
import { finalize } from 'rxjs/operators';
import { ApiNavLink } from './api-list-items.models';


@Component({
  selector: 'app-api-list-items',
  templateUrl: './api-list-items.component.html',
  styleUrls: ['./api-list-items.component.scss']
})
export class ApiListItemsComponent implements OnInit {

  @Input() showAsCards : boolean = false;

  apiNavLinksOther : ApiNavLink[];
  apiNavLinksCategorized : Record<string,ApiNavLink[]>;
  apiNavLinksCategories : string[];
  allAPIsArePublic : boolean = true;
  columnCount: number;
  rowHeight: string;

  constructor(
    private authService: TupAuthService,
    private openApiDataService: OpenApiDataService,
  ) {
    this.resetNavLinks();
    this.authService.authEvents.subscribe( r => {
      if( r == AuthEvent.AuthEventUserDataChanged ) {
        this.openApiDataService.loadDatabase().subscribe(()=>{});
      }
    })
  }

  ngOnInit(): void {
    this.fetchApis();
    this.setResponsiveCols();
  }

  ngOnDestroy(): void {
  }

  ngAfterViewInit() {
  }
  onResize(_event: any) {
        this.setResponsiveCols();
  }

  setResponsiveCols(): void {
    this.columnCount = 1;
    this.rowHeight = "2:1"
    if (window.innerWidth >= 720) {
        this.columnCount = 2;
        this.rowHeight = "3:2"
    }
    if (window.innerWidth >= 1024) {
        this.columnCount = 3;
        this.rowHeight = "3:2"
    }
  }
  fetchApis() {
    this.openApiDataService.ondbLoaded
    // .pipe(
    //   finalize( () => {
    //   }),
    // )
    .subscribe( _ => {

      this.resetNavLinks();

      const apis = this.openApiDataService.getApis();
      for( const api of apis ) {

        if( api.category ) {

          this.apiNavLinksCategorized[api.category] = this.apiNavLinksCategorized[api.category] || [];
          this.apiNavLinksCategorized[api.category].push({
            name: api.name,
            label: api.label,
            short_description: api.short_description,
            public: !!api.public,
          })
          if( ! api.public ) this.allAPIsArePublic = false;

        } else {

          this.apiNavLinksOther.push({
            name: api.name,
            label: api.label,
            short_description: api.short_description,
            public: !!api.public,
          })
          if( ! api.public ) this.allAPIsArePublic = false;
        }

        this.apiNavLinksCategories = Object.keys(this.apiNavLinksCategorized);
      }
    })
  }

  resetNavLinks() {
    this.apiNavLinksOther = [];
    this.apiNavLinksCategorized = {};
    this.apiNavLinksCategories = ["Loading..."];
    this.allAPIsArePublic = true;
  }

}
